import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-security-and-displine',
  templateUrl: './security-and-displine.component.html',
  styleUrls: ['./security-and-displine.component.scss']
})
export class SecurityAndDisplineComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
